import { Navigate } from 'react-router-dom';
import { useAuthApp } from '../app/auth';

const PrivateRoute = ({ children }) => {
    const loggedIn = useAuthApp((state) => state.isLoggedIn)
    return loggedIn ? <>{children}</>: <Navigate to={'/login'} />
}

export default PrivateRoute